import { Check, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { services } from '@/data/services';
import type { City } from '@/data/cities';

interface Props { city: City }

const VillePrestations = ({ city }: Props) => (
  <section className="py-16 md:py-20 px-6 lg:px-8 bg-background">
    <div className="max-w-5xl mx-auto">
      <p className="text-xs font-heading font-semibold uppercase tracking-[0.15em] text-primary mb-2 text-center">Ce que nous proposons</p>
      <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground mb-4 text-center">
        Nos prestations {city.prefix} {city.name}
      </h2>
      <p className="text-muted-foreground text-center max-w-2xl mx-auto mb-12 text-sm">
        Un aperçu des services clés que nous déployons {city.prefix} {city.name} et ses environs.
      </p>

      <div className="space-y-6">
        {services.slice(0, 4).map((service) => {
          const Icon = service.icon;
          return (
            <div key={service.slug} className="p-6 rounded-2xl border border-border bg-card hover:border-primary/20 transition-colors">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-primary/15 to-primary/5 border border-primary/10 flex items-center justify-center shrink-0">
                  <Icon size={20} className="text-primary" strokeWidth={1.5} />
                </div>
                <div className="flex-1">
                  <h3 className="font-heading font-bold text-foreground">{service.title}</h3>
                  <p className="text-xs text-muted-foreground mt-0.5">{service.shortDesc.split('.')[0]}.</p>
                </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 ml-0 md:ml-15">
                {service.bulletPoints.slice(0, 4).map((bp, j) => (
                  <div key={j} className="flex items-start gap-2">
                    <Check size={13} className="text-primary mt-0.5 shrink-0" />
                    <span className="text-xs text-muted-foreground">{bp}</span>
                  </div>
                ))}
              </div>
              <div className="mt-4 ml-0 md:ml-15">
                <Link
                  to={`/services/${service.slug}`}
                  onClick={() => window.scrollTo(0, 0)}
                  className="inline-flex items-center gap-1.5 text-xs text-primary font-heading font-medium hover:gap-2.5 transition-all"
                >
                  En savoir plus <ArrowRight size={12} />
                </Link>
              </div>
            </div>
          );
        })}
      </div>

      {/* Remaining services as compact list */}
      {services.length > 4 && (
        <div className="mt-6 p-5 rounded-xl bg-muted/30 border border-border/50">
          <p className="text-xs font-heading font-semibold text-foreground mb-3">Également disponibles {city.prefix} {city.name} :</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
            {services.slice(4).map((service) => {
              const Icon = service.icon;
              return (
                <Link
                  key={service.slug}
                  to={`/services/${service.slug}`}
                  onClick={() => window.scrollTo(0, 0)}
                  className="flex items-center gap-2.5 py-2 px-3 rounded-lg hover:bg-card transition-colors group"
                >
                  <Icon size={14} className="text-primary shrink-0" strokeWidth={1.5} />
                  <span className="text-xs font-heading font-medium text-foreground group-hover:text-primary transition-colors">{service.title}</span>
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </div>
  </section>
);

export default VillePrestations;
